// extracted by mini-css-extract-plugin
export var contentBody = "_cp-9";
export var headerImage = "_cp-2";
export var imageButton = "_cp-7";
export var imageButtonIcon = "_cp-8";
export var imageHeader = "_cp-4";
export var imageHeaderText = "_cp-5";
export var imageOverlay = "_cp-3";
export var imageTitle = "_cp-6";
export var imageWrapper = "_cp-1";
export var taskList = "_cp-a";
export var widget = "_cp-0";